<template>
  <div>
    <div class="draw" v-if="list.length">
      <p class="item" :class="{active:(idx == 1)}">
        <img :src="list[0].img" />
      </p>
      <p class="item" :class="{active:(idx == 2)}">
        <img :src="list[1].img" />
      </p>
      <p class="item" :class="{active:(idx == 3)}">
        <img :src="list[2].img" />
      </p>
      <p class="item" :class="{active:(idx == 8)}">
        <img :src="list[7].img" />
      </p>
      <p class="btnp" @touchstart="startFn" @touchmove="moveFn" @touchend="drawClick">
        <img src="./../assets/img/draw_go.png" />
      </p>
      <p class="item" :class="{active:(idx == 4)}">
        <img :src="list[3].img" />
      </p>
      <p class="item" :class="{active:(idx == 7)}">
        <img :src="list[6].img" />
      </p>
      <p class="item" :class="{active:(idx == 6)}">
        <img :src="list[5].img" />
      </p>
      <p class="item" :class="{active:(idx == 5)}">
        <img :src="list[4].img" />
      </p>
      <div class="marks" v-if="ismark">
        <span>正在抽奖中,请稍等...</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      start: 0,
      ismark: false, //是否正在抽奖中
      num: 0,
      idx: 0,
      drawNum1:1,
    };
  },
  props:{
    'list': Array,
    'drawNum': Number,
    'prize_id': Number
  },
  methods: {
    startFn() {
      this.start = 0;
    },
    moveFn() {
      this.start = 1;
    },
    drawClick() {
      if (this.start === 1) {
        return;
      }
      this.drawFn();
    },
    drawFn() {
      var _this = this;
      if(_this.drawNum1==0){
        alert('没有抽奖次数');
        // wx.showToast({
        //   title: '没有抽奖次数',
        //   icon: 'none',
        //   duration: 2000
        // })
        return
      }
      var prize_id = window.localStorage.getItem('prize_id');
      console.log(prize_id,123);
      let asyncFn = async () => {
        // if (this.ismark) {
        //   return;
        // }
        // if (this.start == 1) {
        //   return;
        // }
        // let randomNum = this.randomList[ Math.round(Math.random()*(3-0)+0)]
        this.ismark = true;
        // console.log(draw,'抽奖');
        // console.log(_this.prize_id,'抽奖');
        let draw = {
          prize_id:prize_id,
          status:1
        }
        if (draw.status == 1) {
          this.$emit('okDraw')
          this.isPrize = draw.is_award == 1 ? true : false;
          this.list.forEach((e, index) => {
            if (e.id == draw.prize_id) {
              this.init(this.num, index + 1, num => {
                setTimeout(() => {
                  this.ismark = false;
                  this.num = num;
                  this.drawText = this.list[parseInt(num - 1)];
                  _this.$emit('winTispFn',e);
                  _this.drawNum1 --
                }, 500);
              });
            }
            setTimeout(() => {
              var access_token = window.localStorage.getItem('access_token');
              // this.$http.get(`${this.service}questionnaire/draw?access-token=${this.$store.state.access_token}`);
              this.$http.get(`${this.service}questionnaire/draw?access-token=` + access_token);
            }, 1000);
          });
          // return;
        }else {
          this.ismark = false;
        }
      };
      asyncFn();
    },
    init(num, drawNum, fn) {
      var step = 10; //步数
      var add = 0; //现在多少步
      var end = 0; //跑了多少
      var endNum = 48 + ((8 - num) % 8) + drawNum; //最终跑多少
      this.idx = num; //初始值
      var timer = null;
      timer = setInterval(() => {
        add += 11;
        if (add > step) {
          add = 0;
          this.idx++;
          if (this.idx > 8) {
            this.idx = 1;
          }
          end++;
          var surplus = endNum - end;
          if (surplus < 30 && surplus > 20) {
            step = 20;
          }
          if (surplus < 20 && surplus > 10) {
            step = 30;
          }
          if (surplus < 10 && surplus > 5) {
            step = 40;
          }
          if (surplus < 5 && surplus > 2) {
            step = 80;
          }
          if (surplus < 2 && surplus > 0) {
            step = 160;
          }
          if (surplus <= 0) {
            //结束
            clearInterval(timer);
            fn(this.idx);
          }
        }
      }, 40);
    }
  }
};
</script>

<style lang="less" scoped>
.draw {
  width: 5.24rem;
  height: 4.25rem;
  display: flex;
  justify-content:space-evenly;
  flex-wrap: wrap;
  align-items: center;
  margin: 0 auto;
  > p {
    width: 1.66rem;
    height: 1.35rem;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .active {
    position: relative;
    &::before {
      content: "";
      position: absolute;
      background: rgba(238, 21, 21, 0.37);
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      border-radius: .15rem;
    }
  }
  .marks {
    position: absolute;
    color: #fff;
    background: rgba(0, 0, 0, 0.4);
    display: inline-block;
    padding: 0.266667rem;
    font-size: 12px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/draw.vue